<template>
  <div class="category-container" v-if="show">
    <div v-show="activeSlide.id !== 'q1'" class="back paginate" @click.prevent.stop="previous">
      <img :src="requireMedia('icons_UI_chevron_left.svg')"/>
    </div>
    <CategoryCarousel
        v-if="activeSlide"
        :active-slide="activeSlide"
        :result="result"
        @close="show = false"
    />
    <div class="position">
      <div @click.prevent.stop="showSlide('q1')" :class="['pebble', activeSlide.id === 'q1' ? 'active' : '']"></div>
      <div @click.prevent.stop="showSlide('q2')" :class="['pebble', activeSlide.id === 'q2' ? 'active' : '']"></div>
      <div @click.prevent.stop="showSlide('q3')" :class="['pebble', activeSlide.id === 'q3' ? 'active' : '']"></div>
      <div @click.prevent.stop="showSlide('q4')" :class="['pebble', activeSlide.id === 'q4' ? 'active' : '']"></div>
      <div @click.prevent.stop="showSlide('q5')" :class="['pebble', activeSlide.id === 'q5' ? 'active' : '']"></div>
      <div @click.prevent.stop="showSlide('q6')" :class="['pebble', activeSlide.id === 'q6' ? 'active' : '']"></div>
    </div>
    <div v-show="activeSlide.id !== 'q6'" class="next paginate" @click.prevent.stop="next">
      <img :src="requireMedia('icons_UI_chevron_right.svg')"/>
    </div>
    <div class="some-overlay"></div>
  </div>
</template>

<script>

import Categories from "../../Categories";
import CategoryCarousel from "./CategoryCarousel";
import Assets from "../../mixins/Assets.mixin";

let categories = Categories;

export default {
  name: "CategoryContainer",
  components: {CategoryCarousel},
  props: {
    result: Object
  },
  mixins: [Assets],
  data() {
    return {
      categories: categories,
      activeSlide: null,
      show: false
    }
  },
  methods: {
    showSlide(id) {
      this.activeSlide = this.categories.find(category => {
        return category.id === id;
      });
      this.show = true;
    },
    previous() {
      let id = this.activeSlide.id;
      if (id !== 'q1') {
        this.showSlide(id.substring(0, 1) + (parseInt(id.substring(1, 2)) - 1));
      }
    },
    next() {
      let id = this.activeSlide.id;
      if (id !== 'q6') {
        this.showSlide(id.substring(0, 1) + (parseInt(id.substring(1, 2)) + 1));
      }
    },
    requireMedia(image) {
      return require('../../assets/' + image);
    }
  }
}
</script>

<style lang="scss" scoped>
.some-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background-color: rgba(64, 64, 64, 0.85);
}

$vhUnit: 9;
$vwUnit: 16;
$vhUnitMobile: 3.75;
$vwUnitMobile: 6.66;

@function scaleVh($size) {
  @return #{($size/$vhUnit)}vh;
}
@function scaleVw($size) {
  @return #{($size/$vwUnit)}vw;
}
@function scaleMobileVh($size) {
  @return #{($size/$vhUnitMobile)}vh;
}
@function scaleMobileVw($size) {
  @return #{($size/$vwUnitMobile)}vw;
}

.position {
  display: flex;
  position: absolute;
  z-index: 110;

  .pebble {
    cursor: pointer;
    border-radius: 50%;
    border-color: #fff;
    background-color: #fff;
    opacity: 0.6;
  }
}

.paginate {
  position: absolute;
  z-index: 110;
  cursor: pointer;
}

.mobile {
  .position {
    display: none;
  }
}

@media(min-aspect-ratio: 16/9) {
  .position {
    left: scaleVh(671);
    top: scaleVh(634);

    .pebble {
      width: scaleVh(8);
      height: scaleVh(8);
      margin-left: scaleVh(13);
      margin-right: scaleVh(13);
      border-width: 1vh;
    }

    .active {
      opacity: 1;
    }
  }
  .back {
    top: scaleVh(385);
    left: scaleVh(222);
  }
  .next {
    top: scaleVh(385);
    right: scaleVh(224);
  }
  .paginate img {
    height: scaleVh(30);
    width: scaleVh(18);
  }

  // mobile ----

  .mobile {
    .back {
      top: scaleMobileVh(170);
      left: scaleMobileVh(0);
    }
    .next {
      top: scaleMobileVh(170);
      right: scaleMobileVh(0);
    }
    .paginate img {
      height: scaleMobileVh(17);
      width: scaleMobileVh(10);
    }
  }
}

@media(max-aspect-ratio: 16/9) {
  .position {
    left: scaleVw(671);
    top: scaleVw(634);

    .pebble {
      width: scaleVw(8);
      height: scaleVw(8);
      margin-left: scaleVw(13);
      margin-right: scaleVw(13);
      border-width: 1vw;
    }

    .active {
      opacity: 1;
    }
  }
  .back {
    top: scaleVw(385);
    left: scaleVw(222);
  }
  .next {
    top: scaleVw(385);
    right: scaleVw(224);
  }
  .paginate img {
    height: scaleVw(30);
    width: scaleVw(18);
  }

  .mobile {
    .back {
      top: scaleMobileVw(170);
      left: scaleMobileVw(0);
    }
    .next {
      top: scaleMobileVw(170);
      right: scaleMobileVw(0);
    }
    .paginate img {
      height: scaleMobileVw(17);
      width: scaleMobileVw(10);
    }
  }

}
</style>